import { makeStyles } from "@mui/styles";
export const useStyles = makeStyles(() => ({
    ui_module_loader: {
        alignItems: "center",
        display: "flex",
        height: "100%",
        justifyContent: "center",
    },
}));
//# sourceMappingURL=ui_module.loader.css.js.map